/**
 * useParticipateLeads (CHAP-339) - fetch omega-zeta.com participate leads + triage one.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPatch } from '../lib/api.js';
import type {
  ParticipateLeadsResponse,
  ParticipateLeadRow,
  ParticipateLeadStatus,
} from '../../shared/participate-leads.js';

export function useParticipateLeads(slug: string) {
  return useQuery<ParticipateLeadsResponse, Error>({
    queryKey: ['participate-leads', slug],
    queryFn: () => apiGet<ParticipateLeadsResponse>(`/api/c/${slug}/participate-leads`),
    enabled: !!slug,
  });
}

export interface ParticipateLeadPatch {
  status?: ParticipateLeadStatus;
  ownerUserId?: string | null;
  notes?: string | null;
}

export function useUpdateParticipateLead(slug: string) {
  const qc = useQueryClient();
  return useMutation<{ ok: boolean; record: ParticipateLeadRow }, Error, { id: string } & ParticipateLeadPatch>({
    mutationFn: ({ id, ...body }) => apiPatch(`/api/c/${slug}/participate-leads/${id}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['participate-leads', slug] }),
  });
}
